






















import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import { getEmail } from '@/utils/cookie';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';

@Component({
  components: {
    Modal,
  },
})
export default class ModalPreCollectionPdfOnly extends Vue {
  @Prop()
  showPdfOnlyModal!: boolean;

  @Prop()
  closePdfOnlyModal!: () => void;

  @Prop({ required: true })
  currentPreCollection!: PreCollection;

  get userEmail() {
    return getEmail();
  }

  get formSrc() {
    return `https://docs.google.com/forms/d/e/1FAIpQLSdRTvxAufORBZDPj3AgL_3lZRvG98KuG3DrHYJ03hFpaC0xrg/viewform?usp=pp_url&entry.599702293=${
      this.currentPreCollection.name
    } (${this.currentPreCollection.uuid})&entry.732831280=${
      this.userEmail ? this.userEmail : ''
    }`;
  }

  get title() {
    return 'This paper is not ready to be copied as your collection yet';
  }

  width = '800px';

  description = `Unfortunately, this paper is not ready yet to be copied as your own collection.
   You can only download it as a PDF for now. But if you need it for your collection, you can request it by filling up the form below.
    We will make this collectible as your collection once we receive your request.`;
}
